<template>
  <v-card class="normalizer tools-view-card">
    <ToolbarHeader :name="'Normalizer'"/>
    <v-container>
      <section class="ma-5">
        <v-form
            v-model="formOptions.valid"
            ref="form"
        >
          <label>
            Text
          </label>
          <editor
              v-model="form.text"
              @init="initTextEditor"
              width="100%"
              height="60vh">
          </editor>
          <v-row>
            <v-col
                class="w-100"
                cols="12"
                sm="12"
            >
              <v-chip
                  class="ma-1 white--text"
                  close
                  draggable
                  v-for="(filter, index) in NORMALIZER_DATA.filters"
                  :key="index"
                  @drop="onDrop"
                  @dragstart="onDragStart($event, index)"
                  @dragover="onDragOver($event, index)"
                  color="teal"
                  @click:close="removeFilter(index)"
              >
                {{ filter }}
              </v-chip>
              <v-menu offset-y v-if="NORMALIZER_DATA.filters"
                      :close-on-content-click="closeMenuOnContentClick">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      class="ma-1 white--text"
                      v-bind="attrs"
                      v-on="on"
                      color="teal darken-4"
                  >
                    Add filter
                    <v-icon
                        right
                        dark
                    >
                      mdi-plus
                    </v-icon>
                  </v-chip>

                </template>
                <v-list class="normalizer_available-filters_list" no-action>
                  <v-list-item>
                    <v-text-field
                        v-model="search"
                        label="Search filter"
                        required
                    />
                  </v-list-item>
                  <v-list-item
                      v-for="(filter, index) in availableFilters"
                      :key="index"
                      @click="addNewFilter(filter)"
                  >
                    <v-list-item-title>{{ filter }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                        @click="showDialog"
                        class="normalizer_add-filter_custom">
                     <span class="mt-2">
                        Custom
                     </span>
                      <v-icon
                          right
                          color="teal"
                          class="float-right"
                      >
                        mdi-plus
                      </v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                  :disabled="!formOptions.valid"
                  @click="submitForm"
                  color="primary"
                  class="ml-3"
              >
                Run
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <label v-if="NORMALIZER_DATA">
          characters: {{ NORMALIZER_DATA.characterCount }} words: {{ NORMALIZER_DATA.wordacterCount }}
        </label>
        <editor
            :value="NORMALIZER_DATA.normalizedText"
            @init="initTextEditor"
            width="100%"
            height="60vh">
        </editor>
      </section>
      <v-dialog
          v-model="dialog"
          persistent
          max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            Add custom filter
          </v-card-title>
          <v-card-text>
            <v-form
                v-model="customFilterFormOptions.valid"
                ref="customFilterForm"
                v-on:submit.prevent="submitCustomFilterForm"
            >
              <v-text-field
                  v-model="customFilterForm.filter"
                  :rules="customFilterFormOptions.filter"
                  label="Custom filter"
                  required
                  autofocus
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                primary
                text
                @click="closeDialog"
            >
              Cancel
            </v-btn>
            <v-btn
                :disabled="!customFilterFormOptions.valid"
                color="primary"
                class="mr-4"
                @click="submitCustomFilterForm"
            >
              Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import {mapGetters} from "vuex";
import {aceEditorMixin} from "@/mixins/aceEditorMixin";

const formShape = {
  text: ''
};

const customFilterFormShape = {
  filter: ''
};

export default {
  name: "Normalizer",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader
  },
  computed: {
    ...mapGetters([
      'NORMALIZER_DATA',
    ]),
    availableFilters() {
      return this.NORMALIZER_DATA.availableFilters.filter((filter) => {
        return filter.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch('GET_NORMALIZER_DATA', {
      tenant: 'quasiris-tools',
      code: 'normalizer'
    })
        .then((res) => {
          this.setForm(res.text);
        })
  },
  data: () => ({
    form: Object.assign({}, formShape),
    formOptions: {
      valid: false,
      decode: [
        v => !!v || 'Text is required',
      ],
    },
    customFilterForm: Object.assign({}, customFilterFormShape),
    customFilterFormOptions: {
      valid: false,
      filter: [
        v => !!v || 'Filter is required',
      ],
    },
    startPosition: null,
    endPosition: null,
    dialog: false,
    search: '',
    closeMenuOnContentClick: false
  }),
  methods: {
    submitForm() {
      if (!this.form.text) {
        return
      }
      this.$store.dispatch('POST_NORMALIZER_DATA', {
        tenant: 'quasiris-tools',
        code: 'normalizer',
        form: {
          text: this.form.text,
          filters: this.NORMALIZER_DATA.filters
        }
      })
    },
    submitCustomFilterForm() {
      if (!this.customFilterForm.filter) {
        return;
      }

      this.addNewFilter(this.customFilterForm.filter);
      this.dialog = false;
      this.$refs.customFilterForm.reset();
      this.customFilterForm = Object.assign({}, customFilterFormShape);
    },
    setForm(text) {
      this.form.text = text;
    },
    addNewFilter(filter) {
      this.NORMALIZER_DATA.filters.push(filter);
      this.closeMenu();
    },
    closeMenu() {
      this.closeMenuOnContentClick = true;
      setTimeout(() => {
        this.closeMenuOnContentClick = false;
        this.search = '';
      }, 100)
    },
    showDialog() {
      this.dialog = true;
      this.closeMenu();
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.customFilterForm.reset();
    },
    removeFilter(index) {
      this.NORMALIZER_DATA.filters.splice(index, 1);
    },
    onDragStart(evt, index) {
      if (this.NORMALIZER_DATA.filters.length <= 1) {
        return;
      }

      evt.dataTransfer.dropEffect = 'move';
      evt.dataTransfer.effectAllowed = 'move';
      this.startPosition = index;
    },
    onDragOver(evt, index) {
      evt.preventDefault();
      this.endPosition = index;
    },
    onDrop() {
      const beginElement = this.NORMALIZER_DATA.filters[this.startPosition];
      this.NORMALIZER_DATA.filters.splice(this.startPosition, 1);
      this.NORMALIZER_DATA.filters.splice(this.endPosition, 0, beginElement);
    },
  }
}
</script>

<style scoped type="text/scss">
.normalizer_available-filters_list {
  max-height: 350px;
  overflow: auto;
}

.normalizer_add-filter_custom {
  color: #009680;
}

.normalizer_add-filter_custom:hover {
  cursor: pointer;
}
</style>
